import { render, staticRenderFns } from "./PensionSolution.vue?vue&type=template&id=36bcb8e8&scoped=true&"
import script from "./PensionSolution.vue?vue&type=script&lang=ts&"
export * from "./PensionSolution.vue?vue&type=script&lang=ts&"
import style0 from "./PensionSolution.vue?vue&type=style&index=0&id=36bcb8e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bcb8e8",
  null
  
)

export default component.exports